// This file was auto-generated by Fern from our API Definition.
import * as errors from "../../errors/index.js";
export class GatewayTimeoutError extends errors.AgentaApiError {
    constructor(body, rawResponse) {
        super({
            message: "GatewayTimeoutError",
            statusCode: 504,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, new.target.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
        this.name = this.constructor.name;
    }
}
